





































































































import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import Service from '@/api/ForgotService';

import ArrowBack from '@/components/icons/Arrow.vue';
import Mail from '@/components/icons/Mail.vue';
import GmailColorful from '@/components/icons/GmailColorful.vue';
import Outlook from '@/components/icons/Outlook.vue';
import Yahoo from '@/components/icons/social-media/Yahoo.vue';
import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';

@Component({
  components: {
    FilledButton,
    Input,
    Typography,
    ArrowBack,
    Mail,
    GmailColorful,
    Outlook,
    Yahoo,
    ValidationObserver,
    ValidationProvider
  }
})
export default class ForgotPassword extends Vue {
  email = '';
  loading = false;
  success = false;
  service = new Service();
  error: string = '';

  counter: number = 0;
  busy: boolean = false;
  interval: any = {};

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  queryParams: any = {};

  get title() {
    if (this.success) return 'Check your email';
    return 'Forgot your password?';
  }

  get description() {
    if (this.success)
      return 'A message has been sent to you by email with instructions to reset your password';
    return 'Enter your email and Twism will send you instructions to reset your password.';
  }

  created() {
    this.queryParams = Object.assign({}, this.$route.query);
  }

  redirectToContact(): void {
    window.location.href = 'https://support.twism.com/';
  }

  get getMinutes() {
    const { counter: seconds } = this;
    let minutesRemain = Math.floor(seconds / 60).toString();
    let secondsReman = (seconds % 60).toString();
    minutesRemain = minutesRemain.padStart(2, '0');
    secondsReman = secondsReman.padStart(2, '0');
    return `${minutesRemain}:${secondsReman}`;
  }

  decrement() {
    this.interval = setInterval(() => {
      if (this.counter === 0) {
        this.busy = false;
        return;
      }
      this.counter--;
    }, 1000);
  }

  back() {
    if (this.success) {
      this.success = false;
      this.loading = false;
      return;
    }

    if (this.queryParams.goBack) {
      return this.$router.back();
    }

    this.$router.push('/');
  }

  emitResend() {
    clearInterval(this.interval);
    this.submit(false);
  }

  openEmailProvider(provider: 'gmail' | 'outlook' | 'yahoo') {
    const providers = {
      gmail: 'https://mail.google.com',
      outlook: 'https://outlook.live.com/mail',
      yahoo: 'https://mail.yahoo.com'
    };

    window.open(providers[provider], '_blank');
  }

  async submit(valid = true) {
    if (valid) {
      const formRef = this.$refs.observer;
      const formIsValid = await formRef.validate();

      this.error = '';

      if (!formIsValid) {
        setFocusOnFirstInput('input[aria-invalid="true"]');

        return;
      }
    }

    this.loading = true;

    try {
      const res: any = await this.service.forgotPassword({
        mail: this.email,
        inviteCode: this.queryParams.inviteCode
      });

      if (res.response && res.response.data && res.response.data.message) {
        this.error =
          res.response.data.message[0] ||
          'This email is incorrect. Please try again.';

        return;
      }

      if (res && res.status === 201) {
        this.$notification('An email has been sent to you.');
        this.resendEmail();
      }
    } finally {
      this.loading = false;
    }
  }

  resendEmail() {
    this.success = true;

    if (this.busy) return;
    this.busy = true;
    this.counter = 5;
    this.decrement();
  }
}
